<template>
  <div class="mp-root">
    <MpSidebar
      :chats="sortedChats"
      :active-chat-id="activeChatId"
      @select="selectChat"
      @new="createChat"
      @delete="deleteChat"
      @pin="togglePin"
      @rename="renameChat"
    />
    <MpChat
      :chat="activeChat"
      :messages="messages"
      :is-streaming="isStreaming"
      :streaming-text="streamingText"
      :active-tools="activeTools"
      :is-loading-messages="isLoadingMessages"
      :llms="llms"
      :establishments="establishments"
      @send="sendMessage"
      @change-llm="changeLlm"
      @link-establishment="linkEstablishment"
      @clear-establishment="clearEstablishment"
    />
<!--    <MpSettings
      v-if="showSettings"
      :chat="activeChat"
      :assistants="assistants"
      :knowledge-bases="knowledgeBases"
      :establishments="establishments"
      :kb-loading="kbLoading"
      :settings-loading="settingsLoading"
      @update="updateChatSettings"
      @close="showSettings = false"
      @kb-link="kbLink"
      @kb-create="kbCreate"
      @kb-update="kbUpdate"
      @kb-upload-file="kbUploadFile"
      @kb-delete-file="kbDeleteFile"
      @kb-add-example="kbAddExample"
      @kb-delete-example="kbDeleteExample"
    />-->
  </div>
</template>

<script>
import MpSidebar from '@/components/MyPrompt/MpSidebar.vue';
import MpChat from '@/components/MyPrompt/MpChat.vue';
// import MpSettings from '@/components/MyPrompt/MpSettings.vue';
import CHATS from '@/gql/queries/chats.graphql';
import CHAT_MESSAGES from '@/gql/queries/chatMessages.graphql';
import AVAILABLE_LLMS from '@/gql/queries/availableLlmsMyPrompt.graphql';
import ESTABLISHMENT_SET from '@/gql/queries/establishmentSet.graphql';
// import ASSISTANTS from '@/gql/queries/assistants.graphql';
import CREATE_CHAT from '@/gql/mutations/createChat.graphql';
import UPDATE_CHAT from '@/gql/mutations/updateChat.graphql';
import DELETE_CHAT from '@/gql/mutations/deleteChat.graphql';
// import GENERATE_IMAGE from '@/gql/mutations/generateImage.graphql';
// import KNOWLEDGE_BASES from '@/gql/queries/knowledgeBases.graphql';
// import GET_PLACEHOLDERS from '@/gql/queries/placeholder.graphql';
// import CREATE_KB from '@/gql/mutations/createKnowledgeBase.graphql';
// import UPDATE_KB from '@/gql/mutations/updateKnowledgeBase.graphql';
// import DELETE_KB from '@/gql/mutations/deleteKnowledgeBase.graphql';
// import UPLOAD_KB_FILE from '@/gql/mutations/uploadKnowledgeBaseFile.graphql';
// import DELETE_KB_FILE from '@/gql/mutations/deleteKnowledgeBaseFile.graphql';
// import ADD_KB_EXAMPLE from '@/gql/mutations/addKnowledgeBaseExample.graphql';
// import DELETE_KB_EXAMPLE from '@/gql/mutations/deleteKnowledgeBaseExample.graphql';
import { gqlQuery, gqlMutation } from '@/gqlClient.js';
import settings from '@/settings.coffee';

export default {
  name: 'MyPrompt',
  components: { MpSidebar, MpChat /*, MpSettings */ },
  data() {
    return {
      chats: [],
      activeChatId: null,
      messages: [],
      llms: [],
      establishments: [],
      // assistants: [],
      // placeholders: [],
      // knowledgeBases: [],
      isStreaming: false,
      streamingText: '',
      activeTools: [],
      isLoadingMessages: false,
      // kbLoading: false,
      chatLoading: false,
      // settingsLoading: false,
      // showSettings: false,
      ws: null,
    };
  },
  computed: {
    sortedChats() {
      return [...this.chats].sort((a, b) => {
        if (a.is_pinned !== b.is_pinned) return b.is_pinned ? 1 : -1;
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
    activeChat() {
      return this.chats.find(c => c.id === this.activeChatId) || null;
    },
    // activeKb() {
    //   if (!this.activeChat || !this.activeChat.knowledge_base) return null;
    //   return this.knowledgeBases.find(kb => kb.id === this.activeChat.knowledge_base.id) || null;
    // },
  },
  methods: {
    normalizeChat(chat) {
      return {
        ...chat,
        id: parseInt(chat.id, 10),
      };
    },
    async loadChats() {
      const res = await gqlQuery(CHATS);
      if (res.ok) {
        this.chats = (res.body.data.chats || []).map(this.normalizeChat);
      }
    },
    async loadLlms() {
      const res = await gqlQuery(AVAILABLE_LLMS);
      if (res.ok) {
        this.llms = res.body.data.available_llms || [];
      }
    },
    async loadEstablishments() {
      const consultantUid = this.$store.state.profile.data.uid;
      const res = await gqlQuery(ESTABLISHMENT_SET, { consultant_uid: consultantUid, active: true });
      if (res.ok) {
        this.establishments = res.body.data.establishment_set || [];
      }
    },
    async linkEstablishment({ uid }) {
      if (!this.activeChatId) return;
      const res = await gqlMutation(UPDATE_CHAT, { chat_id: this.activeChatId, establishment_uid: uid });
      if (res.ok) {
        const updated = this.normalizeChat(res.body.data.update_chat.chat);
        const idx = this.chats.findIndex(c => c.id === updated.id);
        if (idx !== -1) this.$set(this.chats, idx, updated);
      }
    },
    async clearEstablishment() {
      if (!this.activeChatId) return;
      const res = await gqlMutation(UPDATE_CHAT, { chat_id: this.activeChatId, clear_establishment: true });
      if (res.ok) {
        const updated = this.normalizeChat(res.body.data.update_chat.chat);
        const idx = this.chats.findIndex(c => c.id === updated.id);
        if (idx !== -1) this.$set(this.chats, idx, updated);
      }
    },
    // async loadMeta() { ... },
    // normalizeKb(kb) { ... },
    // async kbCreate({ name, establishment_uid }) { ... },
    // async kbUpdate({ id, name, establishment_uid }) { ... },
    // async kbLink(id) { ... },
    // async kbUploadFile({ filename, content_b64, content_type }) { ... },
    // async kbDeleteFile(fileId) { ... },
    // async kbAddExample({ input_text, output_text }) { ... },
    // async kbDeleteExample(exId) { ... },
    async selectChat(id) {
      id = parseInt(id, 10);
      if (this.activeChatId === id) return;
      this.activeChatId = id;
      this.closeWs();
      this.messages = [];
      this.streamingText = '';
      this.activeTools = [];
      this.isLoadingMessages = true;
      const res = await gqlQuery(CHAT_MESSAGES, { chat_id: id });
      this.isLoadingMessages = false;
      if (res.ok) {
        this.messages = res.body.data.messages || [];
      }
      this.openWs(id);
    },
    async createChat({ name } = {}) {
      this.chatLoading = true;
      try {
        var res = await gqlMutation(CREATE_CHAT, {
          name: name || null,
          llm: 'gpt-5',
        });
        if (res.ok) {
          var chat = this.normalizeChat(res.body.data.create_chat.chat);
          this.chats.push(chat);
          await this.selectChat(chat.id);
        }
      } finally { this.chatLoading = false; }
    },
    async deleteChat(id) {
      const res = await gqlMutation(DELETE_CHAT, { chat_id: id });
      if (res.ok) {
        this.chats = this.chats.filter(c => c.id !== id);
        if (this.activeChatId === id) {
          this.activeChatId = null;
          this.messages = [];
          this.closeWs();
          if (this.chats.length) this.selectChat(this.sortedChats[0].id);
        }
      }
    },
    async togglePin(id) {
      const chat = this.chats.find(c => c.id === id);
      if (!chat) return;
      await this.updateChatField(id, { is_pinned: !chat.is_pinned });
    },
    async renameChat({ id, name }) {
      await this.updateChatField(id, { name });
    },
    // async updateChatSettings(payload) { ... },
    async updateChatField(id, fields) {
      const res = await gqlMutation(UPDATE_CHAT, { chat_id: id, ...fields });
      if (res.ok) {
        const updated = this.normalizeChat(res.body.data.update_chat.chat);
        const idx = this.chats.findIndex(c => c.id === updated.id);
        if (idx !== -1) this.$set(this.chats, idx, updated);
      }
    },
    // handleModelChange(payload) { ... },
    // handleEstablishmentChange(uid) { ... },
    // async handleGenerateImage(payload) { ... },
    // addChatFile(file) { ... },
    changeLlm({ llmId }) {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
      this.ws.send(JSON.stringify({ action: 'change_llm', llm_model_id: llmId }));
    },
    async sendMessage({ text, attachments, llmId }) {
      if (!text || !text.trim()) return;
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
      this.isStreaming = true;
      this.streamingText = '';
      this.messages.push({
        id: null,
        sender: 'user',
        text: text.trim(),
        created_at: new Date().toISOString(),
        attachmentNames: attachments && attachments.length ? attachments.map(function(a) { return a.filename; }) : [],
      });
      if (llmId) {
        this.ws.send(JSON.stringify({ action: 'change_llm', llm_model_id: llmId }));
      }
      this.ws.send(JSON.stringify({ text: text.trim(), attachments: attachments && attachments.length ? attachments : undefined }));
    },
    openWs(chatId) {
      const wsBase = settings.backendUrl.replace(/^http/, 'ws');
      this.ws = new WebSocket(`${wsBase}/ws/chat/${chatId}/`);
      this.ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log('[ws] message reçu:', data);
        if (data.type === 'tool_start') {
          this.activeTools.push(data);
        } else if (data.type === 'tool_end') {
          this.activeTools = this.activeTools.filter(function(t) { return t.tool !== data.tool; });
        } else if (data.type === 'chunk') {
          this.streamingText += data.content;
        } else if (data.type === 'done') {
          this.messages.push({
            id: data.message_id,
            sender: 'assistant',
            text: data.content,
            created_at: new Date().toISOString(),
            files: [],
          });
          this.streamingText = '';
          this.activeTools = [];
          this.isStreaming = false;
        } else if (data.type === 'llm_changed') {
          const chatIdx = this.chats.findIndex(c => c.id === this.activeChatId);
          if (chatIdx !== -1) {
            this.$set(this.chats, chatIdx, { ...this.chats[chatIdx], llm: data.llm_name, llm_model_title: data.llm_title });
          }
        } else if (data.type === 'chat_renamed') {
          console.log('[ws] chat_renamed reçu, data.chat_id=', data.chat_id, typeof data.chat_id, 'chats connus=', this.chats.map(c => [c.id, typeof c.id]));
          const chatIdx = this.chats.findIndex(c => c.id === data.chat_id);
          console.log('[ws] chat_renamed chatIdx trouvé=', chatIdx);
          if (chatIdx !== -1) {
            this.$set(this.chats, chatIdx, { ...this.chats[chatIdx], name: data.name });
            console.log('[ws] chat_renamed appliqué, nouveau nom=', data.name);
          }
        } else if (data.type === 'error') {
          this.isStreaming = false;
          this.streamingText = '';
          this.activeTools = [];
          this.$store.dispatch('notify', { level: 'danger', text: data.message, seconds: 5 });
        }
      };
      this.ws.onerror = () => {
        this.isStreaming = false;
      };
    },
    closeWs() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    },
  },
  async mounted() {
    document.body.style.overflow = 'hidden';
    await Promise.all([this.loadChats(), this.loadLlms(), this.loadEstablishments()]);
    if (this.sortedChats.length) {
      await this.selectChat(this.sortedChats[0].id);
    } else {
      await this.createChat();
    }
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    this.closeWs();
  },
};
</script>

<style scoped>
.mp-root {
  display: flex;
  width: 100%;
  height: 100vh;
  margin-top: -1%;
  overflow: hidden;
  background: #fafaf9;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
</style>
